import { HTTP } from '../../http-common'

export default {
  state: {
    loadedManufacturers: []
  },
  getters: {
    loadedManufacturers (state) {
      return state.loadedManufacturers
    }
  },
  mutations: {
    setLoadedManufacturers (state, payload) {
      state.loadedManufacturers = payload
    },
    createManufacturer (state, payload) {
      state.loadedManufacturers.push(payload)
    },
    updateManufacturer (state, payload) {
      state.loadedManufacturers = state.loadedManufacturers.map(manufacturer => manufacturer.id === payload.id ? payload : manufacturer)
    },
    removeManufacturer (state, id) {
      state.loadedManufacturers = state.loadedManufacturers.filter(manufacturer => {
        return manufacturer.id !== id
      })
    },
    clearLoadedManufacturers (state) {
      state.loadedManufacturers = []
    }
  },
  actions: {
    loadManufacturers ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedManufacturers', [])

      return new Promise((resolve, reject) => {
        HTTP.get('device_manufacturer.json')
          .then(result => {
            console.log(result.data)
            commit('setLoadedManufacturers', result.data.results)
            resolve(result.data)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    createManufacturer ({ commit, getters }, payload) {
      console.log('createManufacturer')
      commit('clearError')
      commit('setLoading', true)
      const newManufacturer = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.post('device_manufacturer.json/', newManufacturer)
          .then(result => {
            console.log(result)
            commit('createManufacturer', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    updateManufacturer ({ commit, getters }, payload) {
      console.log('updateManufacturer')
      commit('clearError')
      commit('setLoading', true)
      const manufacturer = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.patch(`device_manufacturer.json/${payload.id}/`, manufacturer)
          .then(result => {
            console.log(result)
            commit('updateManufacturer', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    removeManufacturer ({ commit }, payload) {
      console.log('removeManufacturer')
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP.delete(`device_manufacturer.json/${payload}`)
          .then(result => {
            console.log('result', result)
            commit('removeManufacturer', payload)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    clearLoadedManufacturers ({ commit }) {
      commit('clearLoadedManufacturers')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/manufacturer/index.js